var audio_rtlignore_default = {
  "fontElementMap": "_1AqjB",
  "customPlayer": "SCJhH",
  "customPlayer_basic": "dFFR5",
  "customPlayer_mobile": "xq9-k",
  "audio_coverImg": "_8BppB",
  "audio_small_cover_image": "DWdx9",
  "audio_icon_button": "hxUAr",
  "audio_contextMenu_wrapper": "wS9yb",
  "customPlayer_with_image": "SFbqu",
  "track_wrapper": "rZExM",
  "trackContainer": "zqnEP",
  "audio_download_icon": "_1zyCm",
  "audio_duration": "NCqow",
  "customPlayer_small_fit": "DhuSR",
  "track_sliders_wrapper": "JJXi4",
  "audio_volume_wrapper": "l2-Wr",
  "volume_slider_wrapper": "oVzBk",
  "audioDetails": "_1UNr7",
  "title": "_8p713",
  "author_name": "yVOS2",
  "dropdown_menu_wrapper": "tiHUi",
  "dropdown_selected_button": "_6LxoG",
  "dropdown_content": "ufQRa",
  "dropdown_content_withIcon": "BzDsF",
  "audio_loader_icon": "HJUQJ",
  "spin": "jdN2q"
};
export {
  audio_rtlignore_default as default
};
//# sourceMappingURL=audio.rtlignore-scss.js.map
